export default __webpack_public_path__ + "static/media/poster_poland.0f87ac7c.jpg";